import {
    ComponentManager,
    ListViewViewModel,
    UIListener,
} from 'radpresentation.htmlclient.defaultviewextensions';
import { IListViewDTO } from 'coreframetypings/dto';

class LVLeitungUIListener extends UIListener
{
    private static readonly TitleErgName = 'ONV_LV_LEITUNG_LV_ERGNAME';

    public override onBeforeListViewRender(context: ListViewViewModel, dto: IListViewDTO)
    {
        dto.ergNamePluralized = LVLeitungUIListener.TitleErgName;
    }
}

ComponentManager.setUIListener('LVLeitungUIListener', LVLeitungUIListener, 'ONVHTMLViewExtension');